import { render, staticRenderFns } from "./FacetPlots.vue?vue&type=template&id=2797a344&scoped=true&"
import script from "./FacetPlots.vue?vue&type=script&lang=js&"
export * from "./FacetPlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2797a344",
  null
  
)

export default component.exports